import { render, staticRenderFns } from "./SportFilter.vue?vue&type=template&id=6499fd96&scoped=true"
import script from "./SportFilter.vue?vue&type=script&lang=js"
export * from "./SportFilter.vue?vue&type=script&lang=js"
import style0 from "./SportFilter.vue?vue&type=style&index=0&id=6499fd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499fd96",
  null
  
)

export default component.exports